/**
 * A fluxible store for keeping track of the steps for a given brief
 */

import { BaseStore } from 'fluxible/addons';

class DraftStepStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.stepKeys = [];
        this.steps = {};
        this.currentStep = null;
    }

    updateSteps(payload) {
        this.stepKeys = Object.keys(payload.steps);
        this.steps = payload.steps;

        this.currentStep =
            this.stepKeys.find(step => {
                return payload.currentPath == this.steps[step].url;
            }) || this.stepKeys[0];
    }

    updateCurrentStep(step) {
        this.currentStep = step;
        this.emitChange();
    }

    getSteps() {
        return this.stepKeys;
    }

    isFirstStep() {
        return this.stepKeys.indexOf(this.currentStep) === 0;
    }

    getCurrentStepId() {
        return this.currentStep;
    }

    getCurrentStep() {
        return {
            id: this.currentStep,
            ...this.steps[this.currentStep],
        };
    }

    getNextStep() {
        let nextStep = null;
        let indexOfCurrentStep = this.stepKeys.indexOf(this.currentStep);

        if (indexOfCurrentStep !== -1) {
            nextStep = this.stepKeys[indexOfCurrentStep + 1]
                ? this.stepKeys[indexOfCurrentStep + 1]
                : null;
        }

        return nextStep;
    }

    urlForStep(step) {
        return this.steps[step].url;
    }
}

DraftStepStore.storeName = 'DraftStepStore';
DraftStepStore.handlers = {
    LOAD_DRAFT_STEPS: 'updateSteps',
    UPDATE_DRAFT_STEP: 'updateCurrentStep',
};

export default DraftStepStore;
